import { useState } from 'react';
import {
	Dialog,
} from '@aleph/shared-components';
import TwoFactorAuthCodeStep from 'wb-reddit/app/common/components/twoFactor/twoFactorAuthCodeStep';
import TwoFactorSuccessStep from 'wb-reddit/app/common/components/twoFactor/twoFactorSuccessStep';

interface IProps {
	onClose: (step: TwoFactorSteps) => void
	type: TwoFactorStepType
	email: string
}

export type TwoFactorSteps = 'authCode' | 'success';
export type TwoFactorStepType = 'enable' | 'disable';

export default function TwoFactorModal({ onClose, type, email }: IProps) {
	const [recoveryCodes, setRecoveryCodes] = useState<string[]>([]);
	const [step, setStep] = useState<TwoFactorSteps>('authCode');

	const closeModal = () => {
		onClose(step);
	};

	const stepProps = {
		onClose: closeModal,
		recoveryCodes,
		setRecoveryCodes,
		setStep,
		type,
		email,
	};

	return 	(<Dialog
		className='z-[1002]'
		isOpen
		onClose={closeModal}
		defaultOpen
	>
		{
			step === 'authCode'
				? <TwoFactorAuthCodeStep {...stepProps} />
				: <TwoFactorSuccessStep {...stepProps} />
		}
	</Dialog>);
}
